var map = {
	"./afiliat/afiliat2.jpg": 99767,
	"./beneficiary/Cultura_oct_2023.png": 72503,
	"./beneficiary/beneficiar.jpg": 49658,
	"./client/client2.jpg": 27451,
	"./client/client3.jpg": 72670,
	"./login/companii/Homepage1.jpg": 64450,
	"./login/companii/Homepage2.jpg": 77357,
	"./login/companii/Homepage3.jpg": 92784,
	"./login/companii/Homepage5.jpg": 95910,
	"./login/utilizatori/Homepage.jpg": 81049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25144;